// extracted by mini-css-extract-plugin
export default {"wrapper":"Roller_wrapper__UU2nA","roller":"Roller_roller__8LCme"};